<template>
    <div class="my-10">
        <div class="flex justify-between mb-5">
            <h1 class="text-2xl font-bold">
                {{ $t('nav.menu') }}
            </h1>
            <SortButton class="bg-white" v-if="currentRelevancy" @on-select="handleRelevancy" :options="SORT_OPTIONS" :defaultValue="currentRelevancy"></SortButton>
        </div>
        <div class="grid grid-cols-4 gap-5">
            <div class="col-span-1 max-md:hidden">
                <FoodSide 
                routeName="foods" 
                :currentCategory="currentCategory" 
                :currentSubscription="currentSubscription" 
                :location="getLocation.id"
                :hideFilters="['isVip', 'currentSubscription']"></FoodSide>
            </div>
            <div class="col-span-3 max-md:col-span-4">
                <div class="grid grid-cols-3 gap-4 max-lg:grid-cols-2 max-md:grid-cols-2">
                    <template v-if="products.length > 0">
                        <router-link v-for="item in products" :key="item?.id" :to="{ name: 'foodRestaurantProductDetail', params: { id: item?.id } }">
                            <FoodCard @likeAction="likeAction" :detail="item">
                            </FoodCard>
                        </router-link>
                    </template>
                    <div v-show="products.length === 0 && loading === false">
                        <p class="text-xl font-medium whitespace-nowrap">{{ $t('page.not_found') }}</p>
                    </div>

                </div>
                <div v-show="loading === true" class="flex justify-center mt-10" role="status">
                    <IconSpinner class="w-12 h-12 mr-2 text-gray-200 animate-spin  fill-main-color">
                    </IconSpinner>

                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import api from '@/api';
import IconSpinner from '@icons/IconSpinner.vue';
import FoodCard from '@cmp/food/FoodCard.vue'
import FoodSide from '@cmp/food/FoodSide.vue'
import SortButton from '@cmp/SortButton.vue'
import { SORT_OPTIONS } from '@/constants'
import { updateLastSeen } from '@/helpers'
export default {
    name: 'products',
    components: {
        FoodCard,
        FoodSide,
        IconSpinner,
        SortButton
    },
    watch: {
        '$route.query.category': {
            //   immediate: true,
            async handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.currentCategory = newValue
                    this.products = []
                    await this.getProducts()
                }
             
            },
        },
        '$route.query.subscription': {
            //   immediate: true,
            async handler(newValue, oldValue) {
                if (newValue !== oldValue) {
                    this.currentSubscription = newValue
                    this.products = []
                    await this.getProducts()
                }

            },
        },
       
        '$route.query.ordering': {
            //   immediate: true,
            async handler(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.currentSort = newValue
                    this.page = 1
                    this.products = []
                    await this.getProducts()
                }
             
            },
        },
        '$route.query.price__range': {
            //   immediate: true,
            async handler(newValue, oldValue) {
                if (newValue != oldValue) {
                    this.currentPrice = newValue
                    this.page = 1
                    this.products = []
                    await this.getProducts()
                }
             
            },
        },
    },
    data() {
        return {
            loading: false,
            products: [],
            currentCategory: null,
            currentSubscription: null,
            currentRelevancy: null,
            currentSort: null,
            currentPrice: null,
            page: 1,
            count: 0,
            next: null,
            SORT_OPTIONS: SORT_OPTIONS,

        }
    },
    methods: {
        infiniteScroll() {
            let scrollTop = document.documentElement.scrollTop
            let scrollHeight = document.documentElement.scrollHeight
            let clientHeight = document.documentElement.clientHeight
            if (scrollTop + clientHeight >= scrollHeight - 650) {
                if (this.next !== null && this.loading === false) {
                    this.page += 1
                    this.getProducts()
                }
            }
        },
        async getProducts() {
            this.loading = true
            try {
                const response = await api.get('exhibition/products/', { params: { categories: this.currentCategory, page: this.page, subscription: this.currentSubscription, ordering: this.currentSort, price__range: this.currentPrice, location: this.getLocation.id } })
                const results = response.data.results
                results.forEach(element => {
                    this.products.push(element)
                });
                this.count = response.data.count
                this.next = response.data.next
            } catch (e) {
                console.log(e)
            }
            this.loading = false

        },
        async likeAction(id, like) {
            if (this.$store.authStatus === false) {
                this.$store.setState('loginModal', true)
                return
            }
            try {
                const response = await api.post(`exhibition/products/${id}/like/`, { is_liked: like });
                this.$store.getLiked('exhibition')
            } catch (e) {
                console.log(e)
            }
        },
        handleRelevancy (e){
            this.currentSort = e
            this.$router.push({ name: 'foods', query: { category: this.currentCategory, page: 1, subscription: this.currentSubscription, ordering: this.currentSort, price__range: this.currentPrice, location: this.getLocation.id } })
        }
    },
    computed: {
        getLocation(){
            return JSON.parse(localStorage.getItem('selectedLocation')) || 1
        }
    },
    mounted() {
        window.addEventListener("scroll", this.infiniteScroll)
    },
    unmounted() {
        window.removeEventListener("scroll", this.infiniteScroll)
    },
    async created() {
        this.currentCategory = this.$route.query.category
        this.currentSubscription = this.$route.query.subscription
        this.currentSort = this.$route.query.sort_by
        this.currentPrice = this.$route.query.price__range
        this.currentRelevancy = this.SORT_OPTIONS.filter((el) => el.value == this.currentSort)[0]
        await this.getProducts()
        updateLastSeen('exhibition_products')

    }
}

</script>

<style scoped></style>
